export const PACKAGE_NAME = 'programMoonJwmAutomationDiscoveryExperiment';
